import Vue from 'vue';
import { sendLog } from '@/api/client-logs';

// vueで検出されたエラー
export default async (error: Error, vue: Vue, info: string): Promise<void> => {
  let message: string = '';
  let stack: string | undefined = undefined;
  if (typeof error === 'string') message = error;
  if (typeof error === 'object') message = error.message;
  if (typeof error === 'object') stack = `${error.stack}`;
  await sendLog({
    level: 'INFO',
    kind: 'unexpected_vue_error',
    message: JSON.stringify({ message, stack })
  });
};

// vueで検出できなかった同期エラー
window.addEventListener(
  'error',
  async (event: ErrorEvent): Promise<void> => {
    let message: string = '';
    let stack: string | undefined = undefined;
    if (typeof event.error === 'string') message = event.error;
    if (typeof event.error === 'object') message = event.error.message;
    if (typeof event.error === 'object') stack = `${event.error.stack}`;
    await sendLog({
      level: 'INFO',
      kind: 'unexpected_window_onerror',
      message: JSON.stringify({ message, stack })
    });
  }
);

// vueで検出できなかった非同期エラー
window.addEventListener(
  'unhandledrejection',
  async (event: PromiseRejectionEvent): Promise<void> => {
    let message: string = '';
    let stack: string | undefined = undefined;
    if (typeof event.reason === 'string') message = event.reason;
    if (typeof event.reason === 'object') message = event.reason.message;
    if (typeof event.reason === 'object') stack = `${event.reason.stack}`;
    await sendLog({
      level: 'INFO',
      kind: 'unexpected_window_onunhandledrejection',
      message: JSON.stringify({ message, stack })
    });
  }
);
